import { defineMessages } from 'react-intl';

export const durationFormFieldDefinitions = defineMessages({
  wrongFormat: {
    id: 'durationFormField.wrongFormat',
    defaultMessage: 'Wrong format (DDD.HH:MM).',
  },
});
